@let renderOvertimeAccountKpi = showOvertimeAccountKpi$ | async;
@let renderProductivityKpi = showProductivityKpi$ | async;
@let renderWorkTimeWeekKpi = showWorkTimeWeekKpi$ | async;
@let renderWorkTimeMonthKpi = showWorkTimeMonthKpi$ | async;
@let renderPlannedTimeWeekKpi = showPlannedTimeWeekKpi$ | async;
@let renderPlannedTimeMonthKpi = showPlannedTimeMonthKpi$ | async;
@let renderOvertimeWeekKpi = showOvertimeWeekKpi$ | async;
@let renderOvertimeMonthKpi = showOvertimeMonthKpi$ | async;
@let staffLayout = staffLayoutStyle$ | async;
@let renderHomeLocation = showHomeLocation$ | async;
@let renderVacationBalance = showVacationBalance$ | async;
@let anyKPIEnabled =
  !!(
    renderOvertimeAccountKpi ||
    renderProductivityKpi ||
    renderWorkTimeWeekKpi ||
    renderWorkTimeMonthKpi ||
    renderPlannedTimeWeekKpi ||
    renderPlannedTimeMonthKpi ||
    renderOvertimeWeekKpi ||
    renderOvertimeMonthKpi ||
    renderHomeLocation ||
    renderVacationBalance
  );

@if (user) {
  <div class="position-relative ps-3">
    <div
      class="d-flex align-items-center"
      [style.height.px]="defaultRowHeight$ | async"
      (mouseenter)="timelineInteractionService.setHoveredRowIndex(index)"
    >
      <div class="w-100">
        <wilson-timeline-user-details
          [user]="user"
          [smallText]="anyKPIEnabled"
        ></wilson-timeline-user-details>
        @if (staffLayout === StaffLayoutStyle.Compact && anyKPIEnabled) {
          <wilson-user-timelines-info-card-kpis
            [user]="user"
            [renderOvertimeAccountKpi]="!!renderOvertimeAccountKpi"
            [renderProductivityKpi]="!!renderProductivityKpi"
            [renderWorkTimeWeekKpi]="!!renderWorkTimeWeekKpi"
            [renderWorkTimeMonthKpi]="!!renderWorkTimeMonthKpi"
            [renderPlannedTimeWeekKpi]="!!renderPlannedTimeWeekKpi"
            [renderPlannedTimeMonthKpi]="!!renderPlannedTimeMonthKpi"
            [renderOvertimeWeekKpi]="!!renderOvertimeWeekKpi"
            [renderOvertimeMonthKpi]="!!renderOvertimeMonthKpi"
            [renderHomeLocation]="!!renderHomeLocation"
            [renderVacationBalance]="!!renderVacationBalance"
          ></wilson-user-timelines-info-card-kpis>
        }
      </div>
    </div>
  </div>
}
